function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import moment from 'moment';
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { debounce } from 'debounce';
import DateRangePicker from "react-dates/esm/components/DateRangePicker";
import "react-dates/esm/initialize";
import { getUpOrDownFromBoolean } from "../../../utils/get-up-or-down-from-boolean";
import { withResponsive } from "../../../utils/with-responsive";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { InputController } from "../InputController";
import { isBlurEvent } from "../../../utils/is-blur-event";
import { returnFirstArgument } from "../../../utils/return-first-argument";
import { getWindowHeight } from "../../../utils/get-window-height";
import { isDisplayedAsModal } from "../../../utils/is-displayed-as-modal";
import { getIsFocusControlled } from "./utils/getIsFocusControlled";
import { mapValueToProps } from "./utils/mapValueToProps";
import { getNumberOfMonths } from "./utils/getNumberOfMonths";
import { getIsVisible } from "./utils/getIsVisible";
import { MAXIMUM_SCREEN_WIDTH_FOR_TWO_MONTH_CALENDAR, LOADING_PLACEHOLDER_TEXT } from "./constants";

var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      endDateId: uuid(),
      startDateId: uuid(),
      focusedInput: null,
      windowHeight: null
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      moment.locale(_this.props.localeCode);

      _this.handleHeightChange();

      global.addEventListener('resize', _this.handleHeightChange);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      var isFocusControlled = getIsFocusControlled(_this.props.focusedInput);

      var _ref = isFocusControlled ? previousProps : previousState,
          previousFocusedInput = _ref.focusedInput;

      var _ref2 = isFocusControlled ? _this.props : _this.state,
          focusedInput = _ref2.focusedInput;

      var _this$props = _this.props,
          onBlur = _this$props.onBlur,
          onFocusChange = _this$props.onFocusChange;
      isBlurEvent(previousFocusedInput, focusedInput) && onBlur();
      if (isFocusControlled) return;
      previousFocusedInput !== focusedInput && onFocusChange(focusedInput);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      global.removeEventListener('resize', _this.handleHeightChange);
    });

    _defineProperty(_assertThisInitialized(_this), "createRef", function (ref) {
      _this.visibilityCheck = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocusChange", function (focusedInput) {
      if (!isDisplayedAsModal(_this.state.windowHeight) && !getIsVisible(_this.visibilityCheck)) return;
      getIsFocusControlled(_this.props.focusedInput) ? _this.props.onFocusChange(focusedInput) : _this.setState({
        focusedInput: focusedInput
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleHeightChange", debounce(function () {
      var windowHeight = getWindowHeight();

      if (windowHeight !== _this.state.windowHeight) {
        _this.setState({
          windowHeight: windowHeight
        });
      }
    }));

    return _this;
  }

  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          displayFormat = _this$props2.displayFormat,
          endDatePlaceholderText = _this$props2.endDatePlaceholderText,
          error = _this$props2.error,
          getIsDayBlocked = _this$props2.getIsDayBlocked,
          initialValue = _this$props2.initialValue,
          isLoading = _this$props2.isLoading,
          isValid = _this$props2.isValid,
          name = _this$props2.name,
          onChange = _this$props2.onChange,
          startDatePlaceholderText = _this$props2.startDatePlaceholderText,
          value = _this$props2.value,
          willOpenAbove = _this$props2.willOpenAbove,
          windowInnerWidth = _this$props2.windowInnerWidth,
          isCalendarIconDisplayed = _this$props2.isCalendarIconDisplayed;
      var _this$state = this.state,
          endDateId = _this$state.endDateId,
          startDateId = _this$state.startDateId;

      var _ref3 = getIsFocusControlled(this.props.focusedInput) ? this.props : this.state,
          focusedInput = _ref3.focusedInput;

      return React.createElement(Fragment, null, React.createElement(InputController, {
        adaptOnChangeEvent: returnFirstArgument,
        error: error,
        initialValue: initialValue,
        inputOnChangeFunctionName: "onDatesChange",
        isFocused: !!focusedInput,
        isValid: isValid,
        mapValueToProps: mapValueToProps,
        name: name,
        onChange: onChange,
        value: value
      }, React.createElement(DateRangePicker, {
        displayFormat: displayFormat,
        endDatePlaceholderText: isLoading ? LOADING_PLACEHOLDER_TEXT : endDatePlaceholderText,
        isDayBlocked: getIsDayBlocked,
        openDirection: getUpOrDownFromBoolean(willOpenAbove),
        startDatePlaceholderText: isLoading ? LOADING_PLACEHOLDER_TEXT : startDatePlaceholderText,
        focusedInput: focusedInput,
        onDatesChange: Function.prototype,
        onFocusChange: this.handleFocusChange,
        endDateId: endDateId,
        startDateId: startDateId,
        customArrowIcon: isLoading ? React.createElement(Icon, {
          name: ICON_NAMES.SPINNER
        }) : React.createElement(Icon, {
          name: ICON_NAMES.ARROW_RIGHT
        }),
        disabled: isLoading,
        customInputIcon: isCalendarIconDisplayed ? React.createElement(Icon, {
          name: ICON_NAMES.CALENDAR
        }) : undefined,
        daySize: 52,
        hideKeyboardShortcutsPanel: true,
        navNext: React.createElement(Icon, {
          name: ICON_NAMES.ARROW_RIGHT
        }),
        navPrev: React.createElement(Icon, {
          name: ICON_NAMES.ARROW_LEFT
        }),
        numberOfMonths: getNumberOfMonths(windowInnerWidth),
        withPortal: isDisplayedAsModal(this.state.windowHeight),
        showClearDates: true
      })), React.createElement("div", {
        ref: this.createRef
      }));
    }
  }]);

  return Component;
}(PureComponent);

Component.displayName = 'DateRangePicker';
Component.defaultProps = {
  displayFormat: 'DD/MM/YYYY',
  endDatePlaceholderText: '',
  error: false,
  focusedInput: undefined,
  getIsDayBlocked: Function.prototype,
  initialValue: undefined,
  isCalendarIconDisplayed: true,
  isLoading: false,
  isValid: false,
  localeCode: 'en',
  name: '',
  onBlur: Function.prototype,
  onChange: Function.prototype,
  onFocusChange: Function.prototype,
  startDatePlaceholderText: '',
  value: undefined,
  willOpenAbove: false,
  windowInnerWidth: MAXIMUM_SCREEN_WIDTH_FOR_TWO_MONTH_CALENDAR
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  displayFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  endDatePlaceholderText: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  focusedInput: PropTypes.oneOf([null, 'startDate', 'endDate']),
  getIsDayBlocked: PropTypes.func,
  initialValue: PropTypes.shape({
    endDate: PropTypes.object,
    startDate: PropTypes.object
  }),
  isCalendarIconDisplayed: PropTypes.bool,
  isLoading: PropTypes.bool,
  isValid: PropTypes.bool,
  localeCode: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  startDatePlaceholderText: PropTypes.string,
  value: PropTypes.shape({
    endDate: PropTypes.object,
    startDate: PropTypes.object
  }),
  willOpenAbove: PropTypes.bool,
  windowInnerWidth: PropTypes.number
} : {};
export var ComponentWithResponsive = withResponsive(Component);